<div class="section-list card ">
    <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header mb-2">
        <ng-container *ngIf="dbSupervOverview_options.showTitle">
           <span class="navbar-brand mb-0 h1">{{dbSupervOverview_options.title}}: <b>{{supervision?.name}}</b> </span> 
        </ng-container>
        <ng-container *ngIf="!dbSupervOverview_options.showTitle && dbSupervOverview_options.title">
            <span class="navbar-brand mb-0 h1"><i class="fa-tachometer-alt fas mr-1"></i> {{dbSupervOverview_options.title}} <small>{{dbSupervOverview_options.titleSub}}</small></span> 
         </ng-container>
        
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <div class="navbar-nav ml-auto">
                <button matTooltip="Select filters for dashboard" type="button" class="btn btn-sm  btn-outline-primary "
                    (click)="filterOpenModal()">
                    <i class="fas fa-filter"></i> Filters
                </button>
            </div>
        </div>
    </nav>

    <div class="animated fadeIn">

        <div class="card-body-kk">
            <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
            <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
            <!-- map -->
            <div class="container-map">
                <app-ol-main #map_db *ngIf="mapcontrol" [title]="'Supervision Issues'" [showCardTitle]="false" [options]="mapcomponent_options"
                    [showButtonLayers]="true"></app-ol-main>
                    <div #mapTooltip id="mapTooltip" class="map_tooltip" >TOOLTIP</div>
            </div>
            <!-- map end-->
            <div *ngIf="dataloaded" class="chart-container-trans">
                <div class="chart-container" [ngClass]="chartcontainerwidth">
                    <app-frms-chart [data]="chartIssueTypeData" [chartType]="'ColumnChart'" [title]="'Issues by Type'"
                        [chartoptions]="chartIssueTypeOptions"></app-frms-chart>
                </div>
                <div class="chart-container" [ngClass]="chartcontainerwidth">
                    <app-frms-chart [data]="chartIssueRelevanceData" [chartType]="'PieChart'"  [chartoptions]="chartIssueRelevanceOptions"></app-frms-chart>
                </div>
                <div class="chart-container" [ngClass]="chartcontainerwidth">
                    <app-frms-chart [data]="chartIssueModuleBrandData" [chartType]="'PieChart'" [chartoptions]="chartIssueModuleBrandOptions">
                    </app-frms-chart>
                </div>                
                <div class="chart-container" [ngClass]="chartcontainerwidth">
                    <app-frms-chart [data]="chartIssueModuleTypeData" [chartType]="'PieChart'" [chartoptions]="chartIssueModuleTypeOptions">
                    </app-frms-chart>
                </div>

            </div>


        </div>
    </div>
</div>